import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const notificationSettingsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.notificationSettings.route,
      lazy: () =>
        import("@pages/panelPages/notificationSetting/notificationSettings"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.notification-settings", [], "index");
        return {};
      },
    },
    permissions: [
      "patient",
      "doctor",
      "staff",
      "super-admin",
      "local-admin",
      "admin",
      "inactive-patient",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
